module.exports = __webpack_public_path__ + "img/stylus-trans-bb.fd4527b1.png";